/** Page-scoped copy and lead intent. The default preserves existing maths pages. */
import { createContext, useContext } from 'react';

import {
  TUITION_SUBJECTS,
  type TuitionSubject,
} from '@shared/tuitionSubjects/tuitionSubjects.js';

const TuitionSubjectContext = createContext<TuitionSubject>('mathematics');
export const TuitionSubjectProvider = TuitionSubjectContext.Provider;

export function useTuitionSubject() {
  const subject = useContext(TuitionSubjectContext);
  return { subject, ...TUITION_SUBJECTS[subject] };
}
